import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

////////// estilos ///////////////
const useStyles = makeStyles((theme) => ({
    formControl: {
      width: "100%",
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  }));



export default function SelectorGrupos({grupos,func ,subG , elegido, actual, setAdd}) {
  ////////// estilos ///////////////
  const classes = useStyles();
  const [hashGrupos, setHashGrupos]= useState({});
  let arrayGrupos = [];
  const [stringsG, setStringsG] = useState([]) 
  const [state, setState] = useState('');
  const [input, setInput]= useState(actual)
  //const [grupos, setGrupos] = useState([]);
  const [selectElegido, setSelectElegido] = useState("")
  useEffect(() => {
    func(elegido)
    let auxHash = {}
    grupos.map( g => {
      auxHash[g.nombre] = g
      arrayGrupos.push(g.nombre)
    })
    setHashGrupos(auxHash)
    setStringsG(arrayGrupos)
    setSelectElegido("")
    // eslint-disable-next-line
  }, [grupos]);
  ///////////////// variables ////////////////
  

  const handleChange = async(event) => {
    setSelectElegido(event.target.value)
    const a = event.target.value
    subG(a.id) 
    setInput("")
    func(a)
  };
  ////////////////////////////////////  ///////
  ////////// funciones ///////////////
  return (
    <div>
      { actual ?
        <FormControl     
          margin="normal"
          fullWidth 
          className={classes.formControl}
          style={{margin:"5px"}}
          >
        <InputLabel id="grupo"> {(input!=="") ? actual : "Grupo" }</InputLabel>
        <Select
          margin="normal"
          labelId="grupo"
          id="grupo"
          fullWidth
          value={state.nombre}
          onChange={handleChange}
          label="grupo"
        >
            <MenuItem  value={""} onClick={()=>setAdd("addgrupo")}>{<i>Crear Nuevo Grupo</i>}</MenuItem>
            {grupos.map((g,index) =>(
                <MenuItem key={index} value={g}>{g.nombre}</MenuItem>
            ))} 
        </Select>
      </FormControl>
      : null}
    </div>
  );
};


